/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Typography } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import PropTypes from "prop-types";
import {
  Container,
  StyledImage,
  StyledFileImage,
  StyledEditIcon,
} from "styles/components/upload-image";
import ImageLibraryDialog from "./ImageLibraryDialog";

const UploadImageWithLibrary = ({
  size,
  url,
  folder,
  setUrl,
  disabled,
  showPencilIcon,
  apiUrl,
  uploadedFileType,
  name,
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleClick = () => {
    if (disabled) return;
    setDialogOpen(true);
  };

  const handleImageSelect = (selectedUrl) => {
    if (setUrl) {
      setUrl(selectedUrl);
    }
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const isImage =
    url?.includes(".png") || url?.includes(".jpg") || url?.includes(".jpeg");

  return (
    <>
      <Container
        size={size}
        onClick={handleClick}
        style={{ flexDirection: "column", width: "auto", height: "auto" }}
      >
        {!!url && isImage && (
          <StyledImage
            src={url?.replace(".pdf", ".png")}
            alt="url"
            style={{ width: "50px" }}
          />
        )}
        {!url && <StyledFileImage size={size} style={{ width: "50px" }} />}

        {url && !isImage && <AttachFileIcon style={{ fontSize: "50px" }} />}

        {name && (
          <Typography variant="body2" color="text.secondary">
            {name}
          </Typography>
        )}
        {!disabled && showPencilIcon && <StyledEditIcon size={size} />}
      </Container>

      <ImageLibraryDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        onImageSelect={handleImageSelect}
        folder={folder}
        apiUrl={apiUrl}
        uploadedFileType={uploadedFileType}
      />
    </>
  );
};

UploadImageWithLibrary.propTypes = {
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  url: PropTypes.string,
  folder: PropTypes.string.isRequired,
  setUrl: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  showPencilIcon: PropTypes.bool,
};

UploadImageWithLibrary.defaultProps = {
  size: "md",
  url: undefined,
  disabled: false,
  showPencilIcon: true,
};

export default UploadImageWithLibrary;
